package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2023_06_30_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Big continues to chase the Anathema down into the hole.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("A Pitmaster attacks Tuesday with a powerful Spectral Fang. The Fang would have done nearly all of his little fairy health had he not been warding bond-ed.  Caper chases and finishes off a Pitmaster who hurt her little friend.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("After defeating the other enemies, Goram chases down the Anathema and bravely jumps blade first into the hole, killing the enemy. Bigs, Goram, and the Anathema corpse fall further down the hole until finally hitting bottom. Bigs collects some Anathema meat.")
    }
}
